/**
 * @fileoverview Time Range Utilities
 * @description Time range presets and interval mappings for App Insights timeline.
 */

export const TIME_RANGES = [
  { key: 'PT1H', label: '1h', description: 'Last 1 hour' },
  { key: 'PT6H', label: '6h', description: 'Last 6 hours' },
  { key: 'PT24H', label: '24h', description: 'Last 24 hours' },
  { key: 'P7D', label: '7d', description: 'Last 7 days' },
  { key: 'P30D', label: '30d', description: 'Last 30 days' },
];

export const DEFAULT_TIME_RANGE = 'PT24H';
export const AUTO_REFRESH_INTERVAL = 30000; // 30 seconds

/**
 * Format a timestamp string for chart display based on time range.
 * Shorter ranges show time only; longer ranges include the date.
 */
export const formatTimestamp = (ts, timeRange) => {
  if (!ts) return '';
  const d = new Date(ts);
  if (isNaN(d.getTime())) return ts;

  if (timeRange === 'PT1H' || timeRange === 'PT6H') {
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }
  if (timeRange === 'PT24H') {
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }
  // 7d, 30d — include date
  return d.toLocaleDateString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
};

/**
 * Format duration in milliseconds to a human-readable string.
 */
export const formatDuration = (ms) => {
  if (ms == null) return '-';
  if (ms < 1) return '<1 ms';
  if (ms < 1000) return `${Math.round(ms)} ms`;
  return `${(ms / 1000).toFixed(2)} s`;
};

/**
 * Format a large number with K/M suffix.
 */
export const formatCount = (n) => {
  if (n == null) return '-';
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return String(n);
};
